<div class="item-container">
    <div class="item-header">
        <h5 class="text-center">{{'BUTTON.VIEW' | translate}} {{"COMMON.DETAIL" | translate}}</h5>
        <div class="edit-icons" mat-dialog-close>
            <i class="material-icons">close</i>
        </div>
    </div>
    <div class="item-content d-flex flex-column">
        <div class="search-cont my-4">
            <div class="s-in form-input" style="position:relative">
                <mat-icon class="input-icon">search</mat-icon>
                <input type="text" placeholder="Search" class="form-control" [(ngModel)]="searchInput"
                    (input)="onSearch($event)" (keyup.enter)="onGo()" />
            </div>
            <div class="go-b" (click)="onGo()">Go</div>
        </div>
        <div class="tab-content pt-0 flex-grow-1 d-flex flex-column">
            <div class="flex-grow-1 white-bg d-flex align-items-center justify-content-center "
                style="position: relative" *ngIf="isSpinnerLoading">
                <div class="custom-loader"></div>
            </div>
            <div class="table-container flex-grow-1 mt-2" *ngIf="!isSpinnerLoading">
                <table class="mt-4" mat-table [dataSource]="dataSourceEmp" #sortEmp="matSort" matSort
                    class="mat-elevation-z8">
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by name"> Name
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <div class="d-flex">
                                <div class="profile-img me-2" [appBackgroundImg]="element.profile_picture"></div>
                                <div class="">
                                    <div>{{element.first_name}} {{element.last_name}}</div>
                                    <div class="steel-blue">{{element.email}}</div>
                                </div>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumnsEmp"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsEmp;"></tr>
                </table>
            </div>
            <div class="mat-table__message" *ngIf="dataSourceEmp.data.length==0">
                <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
            </div>
            <div [ngTemplateOutlet]="pagination" *ngIf="dataSourceEmp.data.length!=0"></div>
        </div>
    </div>

</div>
<ng-template #pagination>
    <div class="pagination-cont">
        <div class="show-item"> {{"COMMON.SIP" | translate}}
            <select class="form-control sel-op ms-2" (change)="onPageSizeChange($event)"
                [(ngModel)]="config.itemsPerPage">
                <option [value]="item" *ngFor="let item of pageSizeOptions"> {{ item }}</option>
            </select>
        </div>
        <div class="page-c">
            <ngb-pagination [collectionSize]="count" [(page)]="config.currentPage" [pageSize]="config.itemsPerPage"
                [maxSize]="maxPaginationSize" (pageChange)="onPageChange($event)"></ngb-pagination>
        </div>
    </div>
</ng-template>